import React, { useEffect, useRef, useState }   from 'react';
import G6 from '@antv/g6';

const { Util } = G6;
const RightChart = ({ info = {} }) => {
  const containerRef = useRef(null);
  const [graph, setGraph] = useState(null);
  const COLORS = ['#4FAF7C', '#F7CCB0', '#FAD546', '#E2211C', '#5B8FF9', '#F46649', '#EEBC20', '#5BD8A6', '#A7A7A7'];
  const colors = {
    B: '#5B8FF9',
    R: '#F46649',
    Y: '#EEBC20',
    G: '#5BD8A6',
    DI: '#A7A7A7',
  }
  const BaseConfig = {
    nameFontSize: 12,
    childCountWidth: 22,
    countMarginLeft: 0,
    propertyCountWidth: 30,
    itemPadding: 16,
    selectedIconWidth: 12,
    nameMarginLeft: 4,
    rootPadding: 18,
  };
  
  
  // const KeyStyle = {
  //   background: {
  //     default: '',
  //     hover: '#e8f7ff',
  //     selected: '#e8f7ff',
  //     actived: '#e8f7ff',
  //   },
  //   borderColor: {
  //     default: '',
  //     hover: '#1890FF',
  //     selected: '#1890FF',
  //     actived: '#1890FF',
  //   },
  // };
  // const ChildCountStyle = {
  //   background: {
  //     default: '#000',
  //     hover: '#E8F7FF',
  //     expanded: '#E6FFFB',
  //     expandedHover: '#CEF5EF',
  //   },
  //   borderColor: {
  //     default: '#1890ff',
  //     expanded: '#5CDBD3',
  //   },
  // };
  const NameStyle = {
    color: {
      default: 'rgba(0, 0, 0, 1)',
      dash: 'rgba(0, 0, 0, .3)',
      hover: '#40A8FF',
      actived: '#40A8FF',
      selected: '#40A8FF',
    },
  };
  const MainStyle = {
    background: {
      // default: '#000',
      hover: '#e8f7ff',
      actived: '#e8f7ff',
      selected: '#e8f7ff',
    },
  };
  const dataTransform = (data) => {
    const changeData = (d, level = 0, color) => {
      const data = {
        ...d,
      };
      data.type = level === 0 ? 'indentedRoot' : 'indentedNode';
      data.hover = false;
  
      if (color) {
        data.color = color;
      }
  
      if (level === 1 && !d.direction) {
        if (!d.direction) {
          data.direction = d.id.charCodeAt(d.id.length - 1) % 2 === 0 ? 'right' : 'left';
        }
      }
  
      if (d.children) {
        data.children = d.children.map((child) => changeData(child, level + 1, data.color));
      }
      // 给定 branchColor 和 0-2 层节点 depth
      if (data.children?.length) {
        data.depth = 0;
        data.children.forEach((subtree, i) => {
          subtree.branchColor = COLORS[i % COLORS.length];
          // dfs
          let currentDepth = 1;
          subtree.depth = currentDepth;
          Util.traverseTree(subtree, child => {
            child.branchColor = COLORS[i % COLORS.length];
  
            if (!child.depth) {
              child.depth = currentDepth + 1;
            }
            else currentDepth = subtree.depth;
            if (child.children) {
              child.children.forEach(subChild => {
                subChild.depth = child.depth + 1;
              })
            }
            // 把没有 children 但有 schemaType.subTypeCount 的节点设置为 collapsed
            // 说明展开需要增量请求 children，未请求前展示 collapsed 状态
            if (!child.children?.length && child.schemaType?.subTypeCount) {
              child.collapsed = true;
            }
            return true;
          })
        });
      }
  
      return data;
    };
    return changeData(data);
  };

  const drawChart = () => {
    if (graph) {
      graph.data(dataTransform(info));
    
      graph.render();
    }
  }

  const createChart = async () =>
  { 
    
    G6.registerNode('flow-rect',
      {
        draw(cfg, group) {
          const {
            name = '',
            variableName,
            variableValue,
            variableUp,
            label,
            collapsed,
            currency,
            status = 'B',
            rate
          } = cfg;
  
          const grey = '#CED4D9';
          const rectConfig = {
            width: 202,
            height: 60,
            lineWidth: 1,
            fontSize: 12,
            fill: '#fff',
            radius: 4,
            stroke: grey,
            opacity: 1,
          };
  
          const nodeOrigin = {
            x: -rectConfig.width / 2,
            y: -rectConfig.height / 2,
          };
  
          const textConfig = {
            textAlign: 'left',
            textBaseline: 'bottom',
          };
  
          const rect = group.addShape('rect', {
            attrs: {
              x: nodeOrigin.x,
              y: nodeOrigin.y,
              ...rectConfig,
            },
          });
  
          const rectBBox = rect.getBBox();
          // bottom percent
          const bottomRect = group.addShape('rect', {
            attrs: {
              x: nodeOrigin.x,
              y: rectBBox.maxY - 60,
              width: 4,
              height: 60,
              radius: 0,
              fill: colors[status],
            },
          });
          this.drawLinkPoints(cfg, group);

          return rect;
        },
        update(cfg, item) {
          const { level, status, name } = cfg;
          const group = item.getContainer();
          let mask = group.find(ele => ele.get('name') === 'mask-shape');
          let maskLabel = group.find(ele => ele.get('name') === 'mask-label-shape');
          if (level === 0) {
            group.get('children').forEach(child => {
              if (child.get('name')?.includes('collapse')) return;
              child.hide();
            })
            if (!mask) {
              mask = group.addShape('rect', {
                attrs: {
                  x: -101,
                  y: -30,
                  width: 202,
                  height: 60,
                  opacity: 0,
                  fill: colors[status]
                },
                // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
                name: 'mask-shape',
              });
              maskLabel = group.addShape('text', {
                attrs: {
                  fill: '#fff',
                  fontSize: 20,
                  x: 0,
                  y: 10,
                  text: name.length > 28 ? name.substr(0, 16) + '...' : name,
                  textAlign: 'center',
                  opacity: 0,
                },
                // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
                name: 'mask-label-shape',
              });
              // const collapseRect = group.find(ele => ele.get('name') === 'collapse-back');
              // const collapseText = group.find(ele => ele.get('name') === 'collapse-text');
              // collapseRect?.toFront();
              // collapseText?.toFront();
            } else {
              mask.show();
              maskLabel.show();
            }
            mask.animate({ opacity: 1 }, 200);
            maskLabel.animate({ opacity: 1 }, 200);
            return mask;
          } else {
            group.get('children').forEach(child => {
              if (child.get('name')?.includes('collapse')) return;
              child.show();
            })
            // mask?.animate({ opacity: 0 }, {
            //   duration: 200,
            //   callback: () => mask.hide()
            // });
            // maskLabel?.animate({ opacity: 0 }, {
            //   duration: 200,
            //   callback: () => maskLabel.hide()
            // });
          }
          this.updateLinkPoints(cfg, group);
        },
        setState(name, value, item) {
          if (name === 'collapse') {
            const group = item.getContainer();
            const collapseText = group.find((e) => e.get('name') === 'collapse-text');
            if (collapseText) {
              if (!value) {
                collapseText.attr({
                  text: '-',
                });
              } else {
                collapseText.attr({
                  text: '+',
                });
              }
            }
          }
        },
        getAnchorPoints() {
          return [
            [0, 0.5],
            [1, 0.5],
          ];
        },
      },
      'rect',
    );
    G6.registerNode('indentedRoot', {
      draw(model, group) {
        const rootColor = '#000';
        const keyShape = group.addShape('rect', {
          attrs: {
            x: -46,
            y: -16,
            width: 92,
            height: 32,
            // fill: "#000",
            radius: 0,
            stroke: '#CFD4DF',
            lineWidth: 2,
            cursor: 'pointer'
          },
          // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
          name: 'key-shape'
        })
    
        if (model.label) {
          const text = group.addShape('text', {
            attrs: {
              text: model.label,
              fill: "#333333",
              fontSize: 20,
              x: 0,
              y: 0,
              textAlign: 'center',
              textBaseline: 'middle',
              cursor: 'pointer',
              fontWeight: 600
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'root-text-shape'
          });
          const textBBox = text.getBBox();
          const width = textBBox.width + 24;
          const height = textBBox.height + 30;
          keyShape.attr({
            x: -width / 2,
            y: -height / 2,
            width,
            height
          })
        }
    
        const { collapsed, children } = model;
        const hasChildren = children?.length;
        let clickCircleY = 22;
        // 子类数量，绘制圆点在节点正下方
        if (hasChildren) {
          const schemaType = model.schemaType;
          const childCountGroup = group.addGroup({
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'child-count-group'
          })
          childCountGroup.setMatrix([1, 0, 0, 0, 1, 0, 0, clickCircleY, 1])
          const countBackWidth = collapsed ? 26 : 12;
          childCountGroup.addShape('rect', {
            attrs: {
              width: countBackWidth,
              height: 12,
              radius: 6,
              stroke: rootColor,
              lineWidth: 2,
              fill: collapsed ? rootColor : '#fff',
              x: -countBackWidth / 2,
              y: -6,
              cursor: 'pointer',
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'child-count-rect-shape',
          });
          const childCountText = childCountGroup.addShape('text', {
            attrs: {
              text: schemaType ? `${schemaType.subTypeCount}` : '0',
              fill: '#fff',
              x: 0,
              y: 0,
              fontSize: 10,
              textAlign: 'center',
              textBaseline: 'middle',
              cursor: 'pointer',
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'child-count-text-shape',
          });
          const childHoverIcon = childCountGroup.addShape('path', {
            attrs: {
              stroke: '#fff',
              lineWidth: 1,
              cursor: 'pointer',
              path: [['M', -3, 2], ['L', 0, -2], ['L', 3, 2]]
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'child-count-expand-icon',
            capture: false
          });
          childCountGroup.addShape('path', {
            attrs: {
              path: [['M', 0, -13], ['L', 0, -6]],
              stroke: rootColor,
              lineWidth: 2,
            }
          })
          childHoverIcon.hide();
    
          // 连接 count 的线段	
          const countLink = group.addShape('path', {
            attrs: {
              path: [['M', 0, 0], ['L', 0, 11]],
              stroke: model.branchColor,
              lineWidth: 2,
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'count-link'
          });
          countLink.toBack();
    
          if (collapsed) {
            childCountGroup.show();
            childCountText.show();
            countLink.show();
          }
          else {
            childCountGroup.hide();
            childCountText.hide();
            countLink.hide();
          }
          clickCircleY += 16;
        }
    
        // 增加子节点 icon	
        const addChildIcon = group.addShape('marker', {
          attrs: {
            x: 0,
            y: clickCircleY,
            r: 6,
            symbol: G6.Marker.expand,
            stroke: '#999',
            fill: '#fff',
            lineWidth: 1,
            cursor: 'pointer'
          },
          // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
          name: 'add-child-icon',
        });
    
        addChildIcon.hide();
        // 连接增加子节点 icon 的线段	
        const addChildLink = group.addShape('path', {
          attrs: {
            path: [['M', 0, clickCircleY - 10], ['L', 0, clickCircleY]],
            stroke: model.branchColor,
            lineWidth: 2,
          },
          // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
          name: 'add-child-link'
        });
        addChildLink.toBack();
        addChildLink.hide();
    
        const bbox = keyShape.getBBox();
        const backContainer = group.addShape('path', {
          attrs: {
            path: hasChildren ? [
              ['M', bbox.minX, bbox.minY],
              ['L', bbox.maxX, bbox.minY],
              ['L', bbox.maxX, bbox.maxY],
              ['L', 10, bbox.maxY],
              ['L', 10, bbox.maxY + 28],
              ['L', -10, bbox.maxY + 28],
              ['L', -10, bbox.maxY],
              ['L', bbox.minX, bbox.maxY],
              ['Z']
            ] : [
              ['M', bbox.minX, bbox.minY],
              ['L', bbox.maxX, bbox.minY],
              ['L', bbox.maxX, bbox.maxY],
              ['L', 10, bbox.maxY],
              ['L', 10, bbox.maxY + 14],
              ['L', -10, bbox.maxY + 14],
              ['L', -10, bbox.maxY],
              ['L', bbox.minX, bbox.maxY],
              ['Z']
            ],
            fill: '#fff',
            opacity: 0
          },
          draggable: true
        })
        backContainer.toBack();
        return keyShape;
      },
      getAnchorPoints() {
        return [
          [0.5, 1],
        ];
      },
      update: undefined,
      setState(name, value, node) {
        if (name === 'closest') {
          const keyShape = node.getKeyShape();
          if (value) keyShape.attr('lineWidth', 2);
          else if (!node.getModel().selected) keyShape.attr('lineWidth', 1);
        }
      }
    });
    
    G6.registerNode('indentedNode', {
      addHoverBack(group, props) {
        const { mainX, mainY, width, height, fill } = props
        group.addShape('rect', {
          attrs: {
            x: mainX,
            y: mainY,
            width,
            height,
            radius: 11,
            fill,
            cursor: 'pointer'
          },
          // capture: false,
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
          name: 'main-shape',
          draggable: true
        });
      },
      addName(group, props) {
        const { label, x = 0, y, fill } = props;
        return group.addShape('text', {
          attrs: {
            text: label,
            x,
            y,
            textAlign: 'start',
            textBaseline: 'top',
            fill,
            fontSize: 14,
            fontFamily: 'PingFangSC-Regular',
            cursor: 'pointer',
          },
          // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
          name: 'not-root-text-shape',
          draggable: true
        });
      },
      draw(model, group) {
        const { collapsed, selected, depth, label } = model;
        // 是否为根节点
        const rootNode = depth === 0;
        // 子节点数量
        const childCount = model.children?.length || 0;
        
        const {
          itemPadding,
          nameMarginLeft,
        } = BaseConfig;
    
        let width = 0;
        const height = 24;
        // let x = -width / 2;
        const x = 14;
        const y = -height / 2;
        const borderRadius = 4;
        // 名称文本
        const text = this.addName(group, { label, x, y });
        
        let textWidth = text.getBBox().width;
        // width = textWidth + 100 + nameMarginLeft;
        width = 500
        
        const keyShapeAttrs = {
          x,
          y,
          width,
          height: 20 + (20 * Math.ceil(model.label.length / 25)),
          radius: borderRadius,
          fill: "#fff",
          stroke: "#CFD4DF",
        };
        
        const keyShape = group.addShape('rect', {
          attrs: keyShapeAttrs,
          // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
          name: 'root-key-shape-rect-shape',
        });
    
        // 底部横线
        // const branchThick = model.depth <= 2 ? 3 : model.depth <= 4 ? 2 : 1;
        // const bottomLine = this.addBottomLine(group, false, {
        //   stroke: model.branchColor || '#AAB7C4',
        //   lineWidth: 3, // model.lineWidth || branchThick || 1,
        //   x,
        //   width
        // });
    
        const mainX = x - 6;
        const mainY = -height - 6;
    
        // hover背景
        // this.addHoverBack(group, {
        //   fill: selected ? MainStyle.background.hover : MainStyle.background.default,
        //   stock: selected ? MainStyle.background.hover : "#000",
        //   height,
        //   width,
        //   mainX,
        //   mainY,
        // });
    
        let nameColor = NameStyle.color.default;
        if (selected) {
          nameColor = NameStyle.color.hover;
        }
        console.log(model, '==================model');
        
        // 名称- (30 * Math.ceil(model.label.length / 20))
        text.attr({
          // y: y - 12 - (10 * Math.ceil(model.label.length / 20)),
          x: 40,
          y: y + 20 + (6 * (Math.ceil(model.label.length / 25) - 1)),
          fill: nameColor,
          fontSize: 22 - (model.id.split('-').length * 2),
          fontWeight: model.id.split('-').length > 2 ? 400 : 600,
          // textAlign: 'center',
          textBaseline: 'middle',
          fontFamily: 'PingFang HK, PingFang HK',
        });
        text.toFront();
        textWidth = text.getBBox().width;
    
        // if (bottomLine) bottomLine.toFront();
        const bbox = group.getBBox();
        const backContainer = group.addShape('path', {
          attrs: {
            path: childCount ? [
              ['M', bbox.minX, bbox.minY],
              ['L', bbox.maxX, bbox.minY],
              ['L', bbox.maxX, bbox.maxY],
              ['L', bbox.minX + 20, bbox.maxY],
              ['L', bbox.minX + 20, bbox.maxY + 20],
              ['L', bbox.minX, bbox.maxY + 20],
              ['Z']
            ] : [
              ['M', bbox.minX, bbox.minY],
              ['L', bbox.maxX, bbox.minY],
              ['L', bbox.maxX, bbox.maxY],
              ['L', bbox.minX, bbox.maxY],
              ['Z']
            ],
            fill: '#fff',
            opacity: 0
          },
          draggable: true
        })
        backContainer.toBack();

        const {
          status = 'B',
        } = model;

        const grey = '#CED4D9';
        const rectConfig = {
          width: 4,
          height: 20 + (20 * Math.ceil(model.label.length / 25)),
          lineWidth: 1,
          fontSize: 12,
          fill: '#fff',
          radius: 4,
          stroke: grey,
          opacity: 1,
        };

        const nodeOrigin = {
          x: -rectConfig.width / 2 + 15,
          y: -rectConfig.height / 2 + 68 + (Math.ceil(model.label.length / 25) - 1) * 10,
        };

        const rect = group.addShape('rect', {
          attrs: {
            x: nodeOrigin.x,
            y: nodeOrigin.y,
            // ...rectConfig,
          },
        });

        const rectBBox = rect.getBBox();
        // bottom percent
        const bottomRect = group.addShape('rect', {
          attrs: {
            x: nodeOrigin.x,
            y: rectBBox.maxY - 60,
            width: 4,
            height: 20 + (20 * Math.ceil(model.label.length / 25)),
            radius: 0,
            fill: COLORS[Number(model.id.split('-')[1]) - 1],
          },
        });
        return keyShape;
      },
      setState(name, value, node) {
        if (name === 'closest' || name === 'selected') {
          const group = node.getContainer();
          const textShape = group.find(child => child.get('name') === 'not-root-text-shape');
          const mainShape = group.find(child => child.get('name') === 'main-shape');
          if (value) {
            if (textShape) {
              textShape.attr('fill', NameStyle.color.hover);
            }
            if (mainShape) {
              mainShape.attr('fill', MainStyle.background.hover);
            }
          } else {
            const selected = node.hasState('selected');
            if (selected) {
              if (textShape) {
                textShape.attr('fill', NameStyle.color.selected);
              }
              if (mainShape) {
                mainShape.attr('fill', MainStyle.background.default);
                mainShape.attr('stock', "#000");
              }
            } else {
              if (textShape) {
                textShape.attr('fill', NameStyle.color.default);
              }
              if (mainShape) {
                mainShape.attr('fill', MainStyle.background.default);
                mainShape.attr('stock', "#000");
              }
            }
          }
        }
      },
    }, 'treeNode');
    
    G6.registerEdge('indentedEdge', {
      afterDraw: (cfg, group) => {
        
        const sourceNode = cfg.sourceNode?.getModel();
        const targetNode = cfg.targetNode?.getModel();
        const color = sourceNode.branchColor || targetNode.branchColor || cfg.color || '#000';
        // const branchThick = sourceNode.depth <= 1 ? 3 : sourceNode.depth <= 3 ? 2 : 1;
        const keyShape = group.get('children')[0];
        keyShape.attr({
          stroke: color,
          lineWidth: 1 // branchThick
        });
        group.toBack();
        
      },
      getControlPoints: (cfg) => {
        const startPoint = {
          ...cfg.startPoint,
        };
        let len = cfg.source && cfg.source.split('-') ? cfg.source.split('-').length : 0;
        
        let endPointX = len > 1 ? 60 : 40;
        
        const endPoint = {
          ...cfg.endPoint,
          x: endPointX,
        };
        return [
          startPoint,
          {
            x: startPoint.x,
            y: endPoint.y,
          },
          endPoint,
        ];
      },
      update: undefined
    }, 'polyline');
    
    G6.registerBehavior('wheel-scroll', {
      getDefaultCfg() {
        return {
          direction: 'y',
          zoomKey: 'ctrl',
          sensitivity: 3,
          // wheel-scroll 可滚动的扩展范围，默认为 0，即最多可以滚动一屏的位置
          // 当设置的值大于 0 时，即滚动可以超过一屏
          // 当设置的值小于 0 时，相当于缩小了可滚动范围
          // 具体实例可参考：https://gw.alipayobjects.com/mdn/rms_f8c6a0/afts/img/A*IFfoS67_HssAAAAAAAAAAAAAARQnAQ
          scalableRange: -64,
        };
      },
    
      getEvents() {
        if (!this.zoomKey || ['shift', 'ctrl', 'alt', 'control'].indexOf(this.zoomKey) === -1) this.zoomKey = 'ctrl';
        return {
          wheel: 'onWheel',
        };
      },
    
      onWheel(ev) {
        const graph = this.graph;
        let keyDown = ev[`${this.zoomKey}Key`];
        if (this.zoomKey === 'control') keyDown = ev.ctrlKey;
        if (keyDown) {
          const sensitivity = this.get('sensitivity');
          const canvas = graph.get('canvas');
          const point = canvas.getPointByClient(ev.clientX, ev.clientY);
          let ratio = graph.getZoom();
          if (ev.wheelDelta > 0) {
            ratio *= (1 + 0.01 * sensitivity);
          } else {
            ratio *= (1 - 0.01 * sensitivity);
          }
          graph.zoomTo(ratio, {
            x: point.x,
            y: point.y,
          });
          graph.emit('wheelzoom', ev);
        } else {
          let dx = ev.deltaX || ev.movementX;
          let dy = ev.deltaY || ev.movementY;
          if (!dy && navigator.userAgent.indexOf('Firefox') > -1) dy = (-ev.wheelDelta * 125) / 3
    
          const width = this.graph.get('width');
          const height = this.graph.get('height');
          const graphCanvasBBox = this.graph.get('group').getCanvasBBox();
    
          let expandWidth = this.scalableRange;
          let expandHeight = this.scalableRange;
          // 若 scalableRange 是 0~1 的小数，则作为比例考虑
          if (expandWidth < 1 && expandWidth > -1) {
            expandWidth = width * expandWidth;
            expandHeight = height * expandHeight;
          }
    
          const { minX, maxX, minY, maxY } = graphCanvasBBox;
    
          if (dx > 0) {
            if (maxX < -expandWidth) {
              dx = 0
            } else if (maxX - dx < -expandWidth) {
              dx = maxX + expandWidth
            }
          } else if (dx < 0) {
            if (minX > width + expandWidth) {
              dx = 0
            } else if (minX - dx > width + expandWidth) {
              dx = minX - (width + expandWidth)
            }
          }
    
          if (dy > 0) {
            if (maxY < -expandHeight) {
              dy = 0
            } else if (maxY - dy < -expandHeight) {
              dy = maxY + expandHeight
            }
          } else if (dy < 0) {
            if (minY > height + expandHeight) {
              dy = 0
            } else if (minY - dy > height + expandHeight) {
              dy = minY - (height + expandHeight)
            }
          }
    
          if (this.get('direction') === 'x') {
            dy = 0;
          } else if (this.get('direction') === 'y') {
            dx = 0;
          }
    
          graph.translate(-dx, -dy);
        }
        ev.preventDefault();
      },
    });
    G6.registerBehavior('drag-branch', {
    
      getEvents: function getEvents() {
        return {
          'node:dragstart': 'dragstart',
          'node:drag': 'drag',
          'node:dragend': 'dragend',
          'node:dragenter': 'dragenter',
          'node:dragleave': 'dragleave',
        };
      },
      dragstart: function dragstart(e) {
        this.set('foundNode', undefined)
        this.origin = {
          x: e.x,
          y: e.y,
        };
        this.target = e.item;
        const graph = this.get('graph');
        // 未配置 shouldBegin 时 默认为 true
        if (this.shouldBegin && !this.shouldBegin(graph.findDataById(this.target?.getID()))) {
          this.began = false;
          return;
        }
        this.began = true;
      },
      dragenter: function dragenter(e) {
        if (!this.began) {
          return;
        }
        const graph = this.get('graph');
        const foundNode = e.item;
        if (foundNode) graph.setItemState(foundNode, 'closest', true);
        this.set('foundNode', foundNode);
      },
      dragleave: function dragleave(e) {
        if (!this.began) {
          return;
        }
        const graph = this.get('graph');
        const foundNode = this.get('foundNode');
        if (foundNode) graph.setItemState(foundNode, 'closest', false);
        this.set('foundNode', foundNode);
      },
      drag: function drag(e) {
        if (!this.began) {
          return;
        }
        // move the delegate
        this.updateDelegate(e);
      },
      dragend: function dragend(e) {
        const graph = this.get('graph');
        const foundNode = this.get('foundNode');
        if (foundNode) {
          graph.setItemState(foundNode, 'closest', false);
        }
        if (!this.began) {
          return;
        }
        this.began = false;
        const { item } = e;
        const id = item.getID();
        const data = graph.findDataById(id);
    
        // remove delegate
        if (this.delegateRect) {
          this.delegateRect.remove();
          this.delegateRect = null;
        }
    
        if (!foundNode) {
          graph.emit('afterdragbranch', { success: false, message: 'Failed. No node close to the dragged node.', branch: data })
          return;
        }
    
        const foundNodeId = foundNode.getID();
    
        let oriParentData;
        Util.traverseTree(graph.get('data'), (d) => {
          if (oriParentData) return false;
          if (d.children?.filter(child => child.id === id)?.length) {
            oriParentData = d;
          }
          return true;
        });
    
        // 未配置 shouldEnd，则默认为 true
        if (this.shouldEnd && !this.shouldEnd(data, graph.findDataById(foundNodeId), oriParentData)) {
          return;
        }
    
        // if the foundNode is a descent of the dragged node, return
        let isDescent = false;
    
        Util.traverseTree(data, (d) => {
          if (d.id === foundNodeId) isDescent = true;
        });
        if (isDescent) {
          const newParentData = graph.findDataById(foundNodeId);
          graph.emit('afterdragbranch', { success: false, message: 'Failed. The target node is a descendant of the dragged node.', newParentData, branch: data })
          return;
        }
    
        const newParentData = graph.findDataById(foundNodeId);
        // 触发外部对数据的改变
        graph.emit('afterdragbranch', { success: true, message: 'Success.', newParentData, oriParentData, branch: data })
        graph.removeChild(data.id);
        setTimeout(() => {
          let newChildren = newParentData.children;
          if (newChildren) newChildren.push(data);
          else newChildren = [data];
          // 更新正在被操作的子树颜色
          Util.traverseTree(data, d => {
            d.branchColor = newParentData.branchColor
          })
          graph.updateChildren(newChildren, newParentData.id);
        }, 600);
      },
      updateDelegate(e) {
        const { graph } = this;
        if (!this.delegateRect) {
          // 拖动多个
          const parent = graph.get('group');
          const attrs = {
            fill: '#F3F9FF',
            fillOpacity: 0.5,
            stroke: '#1890FF',
            strokeOpacity: 0.9,
            lineDash: [5, 5],
          };
    
          const { x: cx, y: cy, width, height, minX, minY } = this.calculationGroupPosition(e);
          this.originPoint = { x: cx, y: cy, width, height, minX, minY };
          // model上的x, y是相对于图形中心的，delegateShape是g实例，x,y是绝对坐标
          this.delegateRect = parent.addShape('rect', {
            attrs: {
              width,
              height,
              x: cx,
              y: cy,
              ...attrs,
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'rect-delegate-shape',
          });
          this.delegateRect.set('capture', false);
        } else {
          const clientX = e.x - this.origin.x + this.originPoint.minX;
          const clientY = e.y - this.origin.y + this.originPoint.minY;
          this.delegateRect.attr({
            x: clientX,
            y: clientY,
          });
        }
      },
      calculationGroupPosition(evt) {
        let node = this.target;
        if (!node) {
          node = evt.item;
        }
    
        const bbox = node.getBBox();
        const { minX, minY, maxX, maxY } = bbox;
    
        return {
          x: Math.floor(minX),
          y: Math.floor(minY),
          width: Math.ceil(maxX) - Math.floor(minX),
          height: Math.ceil(maxY) - Math.floor(minY),
          minX,
          minY,
        };
      },
    });
    G6.registerBehavior('hover-node', {
      getEvents() {
        return {
          'node:mouseover': 'onNodeMouseOver',
          'node:mouseleave': 'onNodeMouseLeave',
          'node:mouseenter': 'onNodeMouseEnter'
        };
      },
      onNodeMouseEnter(ev) {
        const { item } = ev;
        if (!item || item.get('destroyed')) return;
        item.toFront();
        const model = item.getModel();
        const { collapsed, depth } = model;
        const rootNode = depth === 0 || model.isRoot;
        const group = item.getContainer();
    
        if (rootNode) return;
    
        // 控制子节点个数标记
        if (!collapsed) {
          const childCountGroup = group.find(e => e.get('name') === 'child-count-group');
          if (childCountGroup) {
            childCountGroup.show();
          }
        }
        this.graph.setItemState(item, 'hover', true);
      },
      onNodeMouseOver(ev) {
        const shape = ev.target;
    
        // tooltip显示、隐藏
        this.graph.emit('tooltip: show', ev);
    
        // expand 状态下，若 hover 到子节点个数标记，填充背景+显示收起 icon
        const { item } = ev;
        const group = item.getContainer();
        const model = item.getModel();
        if (!model.collapsed) {
          const childCountGroup = group.find(e => e.get('name') === 'child-count-group');
          if (childCountGroup) {
            childCountGroup.show();
            const back = childCountGroup.find(e => e.get('name') === 'child-count-rect-shape');
            const expandIcon = childCountGroup.find(e => e.get('name') === 'child-count-expand-icon');
            const rootNode = model.depth === 0 || model.isRoot;
            const branchColor = rootNode ? '#576286' : model.branchColor;
            if (shape.get('parent').get('name') === 'child-count-group') {
              if (back) {
                back.attr('fill', branchColor || '#fff');
              }
              if (expandIcon) {
                expandIcon.show();
              }
            } else {
              if (back) {
                back.attr('fill', '#fff');
              }
              if (expandIcon) {
                expandIcon.hide();
              }
            }
          }
        }
    
        const addChildIcon = group.find(e => e.get('name') === 'add-child-icon');
        if (addChildIcon) {
          addChildIcon.show();
        }
        const addChildLink = group.find(e => e.get('name') === 'add-child-link');
        if (addChildLink) {
          addChildLink.show();
        }
      },
      onNodeMouseLeave(ev) {
        const { item } = ev;
        const model = item.getModel();
        const group = item.getContainer();
        const { collapsed } = model;
    
        if (!collapsed) {
          const childCountGroup = group.find(e => e.get('name') === 'child-count-group');
          if (childCountGroup) {
            childCountGroup.hide();
          }
    
          const iconsLinkPath = group.find(e => e.get('name') === 'icons-link-path');
          if (iconsLinkPath) {
            iconsLinkPath.hide();
          }
        }
    
        const addChildIcon = group.find(e => e.get('name') === 'add-child-icon');
        if (addChildIcon) {
          addChildIcon.hide();
        }
    
        const addChildLink = group.find(e => e.get('name') === 'add-child-link');
        if (addChildLink) {
          addChildLink.hide();
        }
    
        this.graph.emit('tooltip: hide', ev);
      },
    });
    G6.registerBehavior('click-node', {
      getEvents() {
        return {
          'node:click': 'onNodeClick',
          'canvas:click': 'onCanvasClick'
        };
      },
      onNodeClick(e) {
        const { item, target } = e;
        const shape = target;
        const shapeName = shape.cfg.name;
    
        // 点击增加节点
        // if (shapeName === 'add-child-icon') {
        //   const data = this.graph.findDataById(item.getID());
        //   if (!data.children) data.children = [];
        //   data.children.push({
        //     id: `node-${Math.random()}`,
        //     label: 'new node',
        //     branchColor: data.branchColor,
        //     type: 'indentedNode'
        //   });
        //   this.graph.updateChildren(data.children, data.id)
        //   return;
        // }
        
        // 点击收起/展开 icon
        if (shapeName === 'child-count-rect-shape' || shapeName === 'child-count-text-shape') {
          const model = item.getModel();
          const updatedCollapsed = !model.collapsed;
          this.graph.updateItem(item, { collapsed: updatedCollapsed });
          this.graph.layout();
          return;
        }
    
        // 选中节点
        // this.graph.getNodes().forEach(node => {
        //   this.graph.setItemState(node, 'selected', false);
        // });
        // this.graph.setItemState(item, 'selected', true);
    
        return;
      },
      onCanvasClick(e) {
        this.graph.getNodes().forEach(node => {
          this.graph.setItemState(node, 'selected', false);
        })
      }
    })
    
    let tree = new G6.TreeGraph({
      container: containerRef.current,
      width: containerRef.current.offsetWidth || 650,
      height: containerRef.current.offsetHeight || 800,
      layout: {
        type: 'indented',
        direction: 'LR',
        isHorizontal: true,
        indent: 40,
        getHeight: (node) => {
          // let length = Math.ceil(node.label.length / 20);
          // return 50 + 20 * length;
          if (node.isRoot) {
            return 30;
          }
          if (node.collapsed && node.children?.length) {
            return 36;
          }
          return 52;
        },
        getVGap: () => {
          return 10;
        },
      },
      defaultNode: {
        type: 'custom-node',
      },
      defaultEdge: {
        type: 'indentedEdge',
        style: {
          lineWidth: 2,
          radius: 16,
          endArrow: true,
          // endArrow: {
          //   path: G6.Arrow.triangle(6, 8, 0), // 定义箭头样式
          //   fill: '#A3B1BF'
          // }
        },
      },
      nodeStateStyles: {
        closest: {
          fill: '#f00',
          'node-label': {
            fill: '#f00',
          }
        },
      },
      minZoom: 0.5,
      modes: {
        default: [
          // 'drag-canvas',
          'wheel-scroll',
          'hover-node',
          'click-node',
          // 'drag-branch', {
          //   type: 'collapse-expand',
          //   trigger: 'dblclick'
          // }
        ],
      },
    });
    
    setGraph(tree);
    tree.on('afterrender', e => {
      tree.getEdges().forEach(edge => {
        const targetNode = edge.getTarget().getModel();
        const color = targetNode.branchColor;
        tree.updateItem(edge, { color });
      });
      setTimeout(() => {
        tree.moveTo(32, 32);
        tree.zoomTo(0.7)
      }, 16);
    });

    tree.data(dataTransform(info));
    
    tree.render();
  }

  useEffect(() => {
    if (containerRef && info && JSON.stringify(info) !== '{}') {
      createChart();
    }
  }, []);

  useEffect(() => {
    if (info && JSON.stringify(info) !== '{}') {
      drawChart();
    }
  }, [info]);

  return <div ref={containerRef} style={{ height: "100%" }} />;
};

export default RightChart;